import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import { Virtuoso } from 'react-virtuoso'
import { v4 as uuidv4 } from 'uuid';

import { Item, Section } from 'schema'
import { Droppable, Draggable, DragDrop, Animation, Button } from 'components'
import { ItemBlock, SectionBlock, ItemInput, SectionInput, TagInput, ShowMoreButton } from 'features'
import { dropAlgorithm } from 'utils'
import { FaPlus } from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import { sectionContext, itemContext } from 'context';

const Container = styled.div`
    // width: 100%;
    height: 100%;
    flex-grow: 4;
    overflow: hidden;
    padding-left: ${props => props.full_width ? 'var(--main-padding-width-small)' : 'var(--main-padding-width)'};
    padding-right: ${props => props.full_width ? 'var(--main-padding-width-small)' : 'var(--main-padding-width)'};
    @media (max-width: 1024px) {
        padding-left: var(--main-padding-width-small);
        padding-right: var(--main-padding-width-small);
    }
`

const Title = styled.div`
    font-size: 1.5rem;
    font-weight: bolder;
    padding: 2rem 0.5rem 1rem 0.5rem;
`

class InboxModule extends Component {
    constructor(props){
        super(props);
        this.showMoreIncrement = 50

        // Completed limits
        const sections = Object.values(this.props.data['sections'])
        const sectionLimits = {}
        sections.map(section => {
            sectionLimits[section['sectionID']] = 50
        })

        this.virtuoso = React.createRef();
        this.state = {
            dragIndex: null,
            hoverIndex: null,
            parents: null,
            dragID: null,
            blocks: null,
            blockIDs: null,
            dndBlocks: null,
            dndBlockIDs: null,
            sectionIndex: null,
            dndSectionIndex:null,
            familyCount: null,
            animate: false,
            showAllCompleted: [],
            sectionLimits: sectionLimits

        }   
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.modalID){
            return false
        } else {
            return true
        }
    }

    componentDidUpdate() {
        if(this.requestedFrame){
            cancelAnimationFrame(this.requestedFrame);
            this.requestedFrame = null
        }
    }

    scrollHandler = (isScrolling) => {
        (isScrolling & this.props.inputID) && this.props.setInput(null)
    }

    showMoreCompleted = (sectionID) => {
        const oldLimit = this.state.sectionLimits[sectionID]
        const newLimit = oldLimit + this.showMoreIncrement
        let updatedLimits = {...this.state.sectionLimits}
        updatedLimits[sectionID] = newLimit
        this.setState({
            sectionLimits: updatedLimits
        })
    }

    _buildView = () => {
        let blocks = []
        let blockIDs = []
        let sectionIndex = {}

        // Reorder sectionIDs [filter out archived sections]
        const sectionIDs = Object.values(this.props.data['pages'][this.props.user['inboxID'] || this.props.user['activePages'][0]]['sections'])
        let sections = []
        let activeSections = []
        let archivedSections = []
        sectionIDs.map(sectionID => {
            const section = new Section(this.props.data['sections'][sectionID])
            section['status'] === sectionContext.STATUS.ACTIVE && activeSections.push(section)
            section['status'] === sectionContext.STATUS.ARCHIVE && archivedSections.push(section)
        })
        sections = activeSections
        this.props.user['show_archived'] && sections.push(...archivedSections)

        sections.map(section => {
            let previewBlocks = []
            let sectionBlockIndex = 0

            const sectionID = section.sectionID
            sectionIndex[sectionID] = {start: blocks.length}

            // ItemBlocks
            const sectionView = section.buildView(false, this.props.data, this.props.user['show_completed'])
            let items = []
            let incompleteItems = []
            let completedCount = 0

            if(section['items_visibility'] && sectionView){
                Object.entries(sectionView).forEach(([itemID, node], index) => {
                    // let item_details = JSON.parse(JSON.stringify(node))
                    let item_details = {...node}
                    item_details['itemID'] = itemID
                    item_details['children'] = node.children
                    const item = new Item(item_details)

                    let itemBefore = null
                    let itemAfter = null
                    if(index > 0){
                        const bitem = sectionView[Object.keys(sectionView)[index - 1]]
                        // const bitem_details = JSON.parse(JSON.stringify(bitem.item_details))
                        const bitem_details = {...bitem}
                        bitem_details['itemID'] = Object.keys(sectionView)[index - 1]
                        bitem_details['children'] = bitem.children
                        itemBefore = new Item(bitem_details)
                    }
                    if(index < Object.keys(sectionView).length - 1){
                        const aitem = sectionView[Object.keys(sectionView)[index + 1]]
                        // const aitem_details = JSON.parse(JSON.stringify(aitem.item_details))
                        const aitem_details = {...aitem}
                        aitem_details['itemID'] = Object.keys(sectionView)[index + 1]
                        aitem_details['children'] = aitem.children
                        itemAfter = new Item(aitem_details)
                    }
                    const droppable = dropAlgorithm(item, itemBefore, itemAfter)
                    const toInclude = item['status'] === itemContext.STATUS.INCOMPLETE | 
                                    (item['status'] !== itemContext.STATUS.INCOMPLETE 
                                    & this.props.user['show_completed'] 
                                    & (
                                        completedCount < this.state.sectionLimits[section['sectionID']] 
                                        | this.state.showAllCompleted.includes(sectionID)
                                    ))
                    toInclude && blocks.push(
                        <DragDrop element='ITEM' type='ITEM' accept='ITEM' 
                            index={blocks.length} id={itemID} item={item} disableDrag={this.props.inputID && true}
                            secDropStatus={droppable.dropStatus} secDropIDs={droppable.dropIDs} secondaryIndex={Object.values(item.parents).length} 
                            onHoverHandler={this.onHoverHandler} onDropHandler={this.onDropHandler}
                            onStartDragHandler={this.onStartDragHandler} onEndDragHandler={this.onEndDragHandler}>
                            <ItemBlock key={item['itemID']} itemID={item['itemID']}/>
                        </DragDrop>
                    )
                    toInclude && blockIDs.push(itemID)
                    toInclude && items.push(item)
                    item['status'] === itemContext.STATUS.INCOMPLETE && incompleteItems.push(item)
                    item['status'] === itemContext.STATUS.COMPLETED && completedCount ++
                    previewBlocks.push(<ItemBlock key={itemID} itemID={item['itemID']}/>)
                })

                // Completed items show more button
                if(sectionBlockIndex > 0 & completedCount > this.state.sectionLimits[section['sectionID']] & this.props.user['show_completed']){
                    const increment = completedCount - this.state.sectionLimits[section['sectionID']] > this.showMoreIncrement ? this.showMoreIncrement : completedCount - this.state.sectionLimits[section['sectionID']]
                    blocks.push(<ShowMoreButton text={`+${increment} completed`} n={this.state.sectionLimits[section['sectionID']]} onSelect={() => this.showMoreCompleted(section['sectionID'])}/>)
                    blockIDs.push(`${section['sectionID']}_ShowMoreCompleted`)
                }                
            }
            
            // ItemInput
            let lastParents = incompleteItems.length > 0 ? Object.values(incompleteItems.slice(-1)[0].parents) : []
            incompleteItems.length > 0 && lastParents.push(incompleteItems.slice(-1)[0].itemID)
            if(section['items_visibility']){
                blocks.push(
                    <Droppable secondaryIndex={0} accept='ITEM' element='ITEM_INPUT' sectionID={sectionID}
                        index={blocks.length} id={sectionID + '_ItemInput'} id={sectionID + '_ItemInput'} 
                        secDropStatus={[true]} secDropIDs={[]}
                        onHoverHandler={this.onHoverHandler} onDropHandler={this.onDropHandler}>
                        <ItemInput element='ITEM_INPUT' pageID={this.props.user['inboxID']} sectionID={sectionID} parents={lastParents} id={sectionID + '_ItemInput'}/>
                    </Droppable>
                )
                blockIDs.push(sectionID + '_ItemInput')
            }
        })


        // Placeholder at the bottom
        blocks.push(<div style={{height: '20vh', backgroundColor:'var(--primary-color)'}}></div>)
        blockIDs.push('placeholder')

        // console.log('[ListView.js]', this.props.data, {blocks:blocks, blockIDs: blockIDs, sectionIndex: sectionIndex})
        
        return {blocks:blocks, blockIDs: blockIDs, sectionIndex: sectionIndex}
    }

    // Item handlers [State]
    onStartDragHandler = (index) => {
        let view = this._buildView()
        let blocks = view.blocks
        let blockIDs = view.blockIDs

        // isDragged
        const dragItem = view.blocks[index]
        const updatedDragItem = React.cloneElement(dragItem, {isDragged: true})
        blocks[index] = updatedDragItem
        const dragElementType = updatedDragItem.props.element

        // Remove children
        let dragID = null
        let sectionIndex = null
        let familyCount = 0
        if(dragElementType === 'ITEM'){
            // Remove item children if dragged item is a parent
            dragID = view.blockIDs[index]
            const item = dragItem.props.item
            const sectionID = item['sectionID']
            const familyStats = item.familyCount(this.props.user['show_completed'], this.props.data)
            if(!item['children_visibility']){
                familyCount = 0
            }
            else if(familyStats.completed > this.state.sectionLimits[sectionID]){
                familyCount = this.state.sectionLimits[sectionID] + familyStats.incomplete + 1 // + 1 for the show more button
            } else {
                familyCount = familyStats.total
            }
            sectionIndex = view.sectionIndex
            if(familyCount > 0){
                // Remove children
                blocks.splice(index+1,familyCount)
                blockIDs.splice(index+1,familyCount)

                // Adjust sectionIndex for sections after section of dragged item
                const sectionIDs = Object.keys(sectionIndex)
                const dragSectionID = blocks[index].props.item.sectionID
                const dragSectionPos = sectionIDs.indexOf(dragSectionID)
                sectionIDs.slice(dragSectionPos,sectionIDs.length+1).map(sectionID => {
                    sectionIndex[sectionID]['start'] -= familyCount
                    sectionIndex[sectionID]['end'] -= familyCount
                })
            }
        } else if (dragElementType === 'SECTION'){
            // Remove section items
            dragID = view.blockIDs[index]
            sectionIndex = view.sectionIndex
            familyCount = sectionIndex[dragID]['end'] - sectionIndex[dragID]['start']
            blocks.splice(index+1, familyCount)
            blockIDs.splice(index+1, familyCount)
        }
        
        this.setState({
            dragIndex: index,
            dragID: dragID,
            blocks: blocks,
            blockIDs: blockIDs,
            dndBlocks: blocks,
            dndBlockIDs: blockIDs,
            sectionIndex: {...sectionIndex},
            dndSectionIndex: {...sectionIndex},
            familyCount: familyCount
        })
        // console.log('Start drag',{item: updatedDragItem, id: dragID, index: index, familyCount: familyCount})
    }

    onEndDragHandler = () => {
        this.setState({
            dragIndex: null,
            hoverIndex: null,
            parents: null,
            dragID: null,
            blocks: null,
            blockIDs: null,
            dndBlocks: null,
            dndBlockIDs: null,
            sectionIndex: null,
            dndSectionIndex:null,
            familyCount: null
        })
    }

    onHoverHandler = (x, y, dropID, secIDs, item) => {

        const t0 = performance.now()
        const i = {...item}
        if(item.props.type === 'SECTION'){
            return 
        }
        if((dropID !== this.state.dragID | !this.state.hoverIndex) && !this.requestedFrame) {
            let blocks = Object.values(this.state.dndBlocks)
            let blockIDs = Object.values(this.state.dndBlockIDs)

            // Constants
            let targetIndex = blockIDs.indexOf(dropID)
            const dragIndex = this.state.hoverIndex || blockIDs.indexOf(this.state.dragID)
            const targetItem = blocks[targetIndex]

            const dragItem = blocks[dragIndex]
            const targetSectionID = targetItem.props.element === 'SECTION' ? targetItem.props.id
                                    : targetItem.props.element === 'ITEM_INPUT' ? targetItem.props.sectionID 
                                    : targetItem.props.children.props.item.sectionID
            let dragSectionID = dragItem.props.children.props.item.sectionID // Get based on dragIndex

            // Drag into new section [problem is that is abit too late]
            // if(targetSectionID !== dragSectionID && targetIndex > dragIndex){
            //     targetIndex -= 1
            // }

            if(targetItem.props.element === 'ITEM_INPUT' & targetIndex > dragIndex){
                // Don't do anything
            } else if (targetItem.props.element === 'SECTION' & targetIndex < dragIndex){
                // Don't do anything
            } else {
                // Update dragItem
                const itemBefore = targetIndex === 0 ? null 
                                    : blocks[targetIndex - 1].props.element === 'ITEM' ? blocks[targetIndex - 1].props.children.props.item 
                                    : null
                const itemAfter = targetIndex === blocks.length ? null 
                                : blocks[targetIndex + 1].props.element === 'ITEM' ? blocks[targetIndex + 1].props.children.props.item 
                                : null
                const item = dragItem.props.children.props.item
                const updatedDroppable = dropAlgorithm(item, itemBefore, itemAfter)
                const updatedDragItem = React.cloneElement(dragItem, {secDropStatus: updatedDroppable.dropStatus, secDropIDs: updatedDroppable.dropIDs})
                
                // Animation
                if(this.state.animate){
                    // console.log('set animation', {animation: targetIndex > dragIndex ? 'moveUp' : 'moveDown', targetIndex: targetIndex, dragIndex: dragIndex})
                    let animateTarget = React.cloneElement(blocks[targetIndex], {shouldAnimate: true, animation: targetIndex > dragIndex ? 'moveUp' : 'moveDown'})
                    blocks[targetIndex] = animateTarget
                }

                // Update block order
                blocks.splice(dragIndex,1)
                blockIDs.splice(dragIndex,1)
                blocks.splice(targetIndex,0,updatedDragItem)
                blockIDs.splice(targetIndex,0,this.state.dragID)

                if(this.state.hoverIndex !== targetIndex){
                    // rAF setState
                    this.requestedFrame = requestAnimationFrame(() => {
                        this.setState({
                            hoverIndex: targetIndex,
                            dragIndex: dragIndex,
                            dndBlocks: blocks,
                            dndBlockIDs: blockIDs,
                            parents: secIDs
                        })
                    })  
                }
                
            }
        }
        
    }

    onDropHandler = (props, x, y, dropID, secIDs, valid) => {
        const item = props.item
        // Parent index
        let blocksBefore = this.state.dndBlocks.slice(0,this.state.hoverIndex).reverse()
        let parentIndex = 0
        let sectionID = null
        if(this.state.hoverIndex === 0){
            sectionID = Object.keys(this.state.sectionIndex)[0]
        } else {
            blocksBefore.every((block,index) => {
                let parents = null
                try {
                    sectionID = block.props.element === 'ITEM' ? block.props.children.props.item.sectionID
                                : block.props.element === 'SECTION' ? block.props.id
                                : null
                    parents = Object.values(block.props.children.props.item.parents)
                } catch {
                    
                    return false
                }
                if(_.isEqual(parents, this.state.parents.slice(0,y))){
                    parentIndex += 1
                } 
                return true
            })
        }
        
        // Add check if dropped in the original position before commit
        if(!_.isEqual(this.state.blockIDs, this.state.dndBlockIDs)){
            this.props.commitDND(this.props.data, item, this.state.parents.slice(0,y), parentIndex, sectionID,this.props.uid) 
        } else if (_.isEqual(this.state.blockIDs, this.state.dndBlockIDs) && (Object.values(item.parents).length !== y)) {
            this.props.commitDND(this.props.data, item, this.state.parents.slice(0,y), parentIndex, sectionID,this.props.uid) 
        } else {

        }
    }

    render() { 
        const view = this.state.dndBlocks ? null : this._buildView()
        const blocks = this.state.dndBlocks ? this.state.dndBlocks : view.blocks
        const blockIDs = this.state.dndBlockIDs ? this.state.dndBlockIDs : view.blockIDs
        const scroll = blockIDs.indexOf(this.props.inputID) > 0 & this.virtuoso.current

        scroll && this.virtuoso.current.scrollToIndex({
            index: blockIDs.indexOf(this.props.inputID),
            align: 'center',
        });
        return (
            <Container full_width={this.props.user ? this.props.user.full_width : null}>
                <Title>Inbox</Title>
                <Virtuoso key='virtuoso'
                    ref={this.virtuoso} 
                    isScrolling={(s) => this.scrollHandler(s)}
                    style={{ height: '100vh'}}
                    totalCount={blocks.length}
                    itemContent={index => (blocks[index])}
                    computeItemKey={index => (blockIDs[index])}
                    useWindowScroll
                />
            </Container>
            
        )
    }
}

const mapStateToProps = state => {
    return {
        history: state.db,
        uid: state.auth.uid,
        user: state.auth.user,
        // data: state.db.data,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,
        inputID: state.content.inputID,
        modalID: state.content.modalID,

        // List View DND
        dragIndex: state.dnd.dragIndex,
        dragID: state.dnd.dragID,
        blocks: state.dnd.blocks,
        blockIDs: state.dnd.blockIDs,
        dndBlocks: state.dnd.blocks,
        dndBlockIDs: state.dnd.blockIDs,
        sectionIndex: state.dnd.sectionIndex,
        dndSectionIndex: state.dnd.sectionIndex,
        familyCount: state.dnd.familyCount
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setInput: (inputID) => dispatch(actionCreators.setInput(inputID)),
        commitDND: (data, item, parents, parentIndex, targetSectionID, uid) => dispatch(actionCreators.commitDND(data, item, parents, parentIndex, targetSectionID, uid)),
        // commitDND: (uid,data,item,parents,parentIndex,targetSectionID) => dispatch(actionCreators.commitDND(uid,data,item,parents,parentIndex,targetSectionID)),
        updateSection: (uid, pageID, sectionID, section) => dispatch(actionCreators.updateSection(uid, pageID, sectionID, section)),
        updatePage: (page, data) => dispatch(actionCreators.updatePage(page, data)),
        listViewStart: (dragIndex, dragID, blocks, blockIDs, sectionIndex, familyCount) => dispatch(actionCreators.listViewStart(dragIndex, dragID, blocks, blockIDs, sectionIndex, familyCount)),
        listViewHover: (hoverIndex, dragIndex, blocks, blockIDs, parents) => dispatch(actionCreators.listViewHover(hoverIndex, dragIndex, blocks, blockIDs, parents)),
        listViewReset: () => dispatch(actionCreators.listViewReset()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(InboxModule);